import React , { useRef } from 'react';
import {
    Show, 
    EditButton,
    SimpleShowLayout,
    CardActions,
    ListButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment'
import Card from '@material-ui/core/Card';
import ReactToPrint from "react-to-print";
import { makeStyles } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode'
import PrintIcon from '@material-ui/icons/Print';
import Printview from './PrintPhysical'
import PrintFullview from './PrintFullPhy'
//import BarcodeCom from './BarcodeCom'
import ErrorBoundary from '../ErrorBoundary';


const ProcessingViewActions = ({ basePath, data }) => (
    <CardActions>
         {
             data && data.ssn  && <ListButton basePath={'/physicals?filter=%7B"ssn"%3A"' + `${data.ssn}` +'"%7D&order=DESC&page=1&perPage=25&sort=id'} label='Physical List'/>
         }
         
         
    </CardActions>
);

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    }
};

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '2px', 
        zIndex: 2,
        width: '100%',
    },

    title: {
        display: 'inline-block', 
        height: '25px',
        zIndex: 2,
        width: '100%',
        alignItems: 'middle',
        textAlign: 'center',
        border: 'double',
        fontSize: '14',
        fontWeight: 'bold',
        verticalAlign: 'middle'
    },

    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    },

    table: {
        border: '1px solid black',
        width: '100%',
        fontSize: '10px',
        cellSpacing: '10px',
        padding: '10px',
        borderCollapse: 'collapse',
        textAlign: 'left', 
        marginLeft: 'auto', 
        marginRight: 'auto',
        marginTop: '10px' 
    },


    tableOuter: {
        margin: "20px 10px 2px 20px",   
        borderCollapse:"collapse",
        padding: "0",
        width: "775px",
        },
    
    tableOuterPrint: {
        margin: "20px 10px 2px 20px",   
        borderCollapse:"collapse",
        padding: "0",
        width: "775px",
        display: "none",
        '@media print': {
            display: "inherit",
            visibility: "hidden"
        }
    },

    tableNoBorder: {
        border: '0',
        width: '100%',
        fontSize: '10px',
        cellSpacing: '0',
        padding: '5px',
        borderCollapse: 'collapse',
        textAlign: 'left', 
        marginLeft: 'auto', 
        marginRight: 'auto',
        marginTop: '10px' 
    },

    textCenter: {
        textAlign: 'center'
    },

    pagebreak: { 
        pageBreakAfter : 'always',
        marginTop: '10px' ,
        width: '100%',
       
    } ,

    pagebreakbefore: {
        breakBefore : 'page'
    },

    subHeading: {
        textAlign: 'center', 
        fontSize: '13px',
        fontWeight: 'bold',
        marginTop: '10px' 
    },
    
    img: {
        width: '18em',
        minWidth: '1em',
        maxWidth: '20em',
        maxHeight: '20em',
        margin: '1em'
    },
    
    signature : {
        width: '60px',
        height: '12px',
    },

    altimg: {
        width: '650px',
        height: '600px',
    },

    printOnly : {
        display: "none",
        '@media print': {
            display: "inherit",
            visibility: "hidden"
        }

    }
});

const Title =({record}) =>{
    return <span>{record.last_name + ',  ' + record.first_name}</span>
}

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <div ><Printview record={record} classes={classes} ref={componentRef} /></div>
            <br />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };

  const PrintFull = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <div ><PrintFullview record={record} classes={classes} ref={componentRef} /></div>
            <br />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
          
      </div>
    );
  };

const PhysicalView = ({ classes, ...props }) => (
    <center>
    <ErrorBoundary>
    <Show 
    {...props}  
    title={<Title/>}
    actions={<ProcessingViewActions/>} 
    >     
        <SimpleShowLayout >     
        <PrintFull />
        <Print />
        </SimpleShowLayout>     
    </Show>
    </ErrorBoundary>
    </center>
);

export default withStyles(styles)(PhysicalView);
